export default "__VITE_ASSET__E4Qq5bag__"